import React from "react";
import PropTypes from "prop-types";
import { addThousandsSeparator } from "utils/helpers";

import "./styles.scss";

// "DUE TODAY" breakdown for Progressive Leasing offers when the cart contains
// an installation fee (sku inst-1000). The installation fee is not part of
// the lease, but it is collected today along with the $1.00 initial payment.
const DueTodayBreakdown = ({ initialPayment, installationFee, className }) => {
  const fee = parseFloat(installationFee) || 0;
  if (fee <= 0) return null;

  const initial = parseFloat(initialPayment) || 1;
  const total = initial + fee;

  return (
    <div className={`due-today-breakdown${className ? ` ${className}` : ""}`}>
      <div className="due-today-breakdown__title">Due Today</div>
      <div className="due-today-breakdown__row">
        <div className="due-today-breakdown__box">
          <div className="due-today-breakdown__label">Initial payment</div>
          <div className="due-today-breakdown__amount">
            ${addThousandsSeparator(initial)}
          </div>
          <div className="due-today-breakdown__note">
            (plus applicable taxes)
          </div>
        </div>
        <div className="due-today-breakdown__operator">+</div>
        <div className="due-today-breakdown__box">
          <div className="due-today-breakdown__label">Installation fees</div>
          <div className="due-today-breakdown__amount">
            ${addThousandsSeparator(fee)}
          </div>
          <div className="due-today-breakdown__note">
            (not included in the lease)
          </div>
        </div>
        <div className="due-today-breakdown__operator">=</div>
        <div className="due-today-breakdown__box due-today-breakdown__box--total">
          <div className="due-today-breakdown__label">Total due today</div>
          <div className="due-today-breakdown__amount">
            ${addThousandsSeparator(total)}
          </div>
        </div>
      </div>
      <p className="due-today-breakdown__footnote font-italic">
        Installation fees are not included in your lease but will be collected
        today along with the initial payment of your lease.
      </p>
    </div>
  );
};

DueTodayBreakdown.propTypes = {
  initialPayment: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  installationFee: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

DueTodayBreakdown.defaultProps = {
  initialPayment: 1,
  installationFee: 0,
  className: "",
};

export default DueTodayBreakdown;
